import { z } from "zod";

export const PaginationSchema = z.object({
  offSet: z.number(),
  limit: z.number(),
  total: z.number(),
});

export const DomainModelSchema = z.object({
  id: z.number().optional(),
});

export const AuditableDomainEntitySchema = DomainModelSchema.extend({
  createdOn: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedOn: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
});
